'use client';

import React from 'react';
import { ROUTES } from '@/constants/routes/default';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { signOut, useSession } from 'next-auth/react';
import { cn } from '@/helpers/common';
import HeaderDropdownJC from './HeaderDropdownJC';

const desktopLinkCn =
  'second-font tracking-wider text-sm font-semibold text-jc-botticelli py-2 px-3 no-underline default-transition hover:text-jc-my-sin';

const HeaderJC = () => {
  const pathname = usePathname();
  const { data: value } = useSession();
  const session = value;
  return (
    <header className="flex md:px-10 max-md:px-4 min-h-20 bg-jc-firefly">
      <div className="max-w-280 w-full h-full flex justify-between items-center m-auto flex-wrap gap-4">
        <Link href={ROUTES.home} aria-label="Johnson Jobs home">
          <Image
            className="max-[400px]:w-21.5 min-[400px]:w-43 max-[400px]:h-2 min-[400px]:h-4"
            width="172"
            height="16"
            alt="Johnson Jobs"
            src="https://assets.johnsonjobs.com/johnsonjobs/jc-logo.png"
            unoptimized
            priority
          />
        </Link>
        <nav aria-label="Main" className="md:flex max-md:hidden items-center gap-2">
          <a
            aria-current={pathname === ROUTES.jobs ? 'page' : undefined}
            className={cn(desktopLinkCn, { 'text-jc-my-sin': pathname === ROUTES.jobs })}
            href={ROUTES.jobs}
          >
            SEARCH JOBS
          </a>
          {session ? (
            <>
              <a
                aria-current={pathname === ROUTES.profile ? 'page' : undefined}
                className={cn(desktopLinkCn, { 'text-jc-my-sin': pathname === ROUTES.profile })}
                href={ROUTES.profile}
              >
                WORK PREFERENCES
              </a>
              <a
                aria-current={pathname === ROUTES.partners ? 'page' : undefined}
                className={cn(desktopLinkCn, { 'text-jc-my-sin': pathname === ROUTES.partners })}
                href={ROUTES.partners}
              >
                PARTNERSHIP
              </a>
              <button className={desktopLinkCn} onClick={() => signOut()}>
                SIGN OUT
              </button>
            </>
          ) : (
            <>
              <a
                aria-current={pathname === ROUTES.partners ? 'page' : undefined}
                className={cn(desktopLinkCn, { 'text-jc-my-sin': pathname === ROUTES.partners })}
                href={ROUTES.partners}
              >
                PARTNERSHIP
              </a>
              <a className={cn(desktopLinkCn)} href={ROUTES.signin}>
                SIGN IN
              </a>
              <a
                className={cn(
                  'h-9 default-transition second-font tracking-wider',
                  'text-jc-firefly rounded-md px-5 py-2 bg-jc-my-sin text-sm font-semibold text-center hover:bg-jc-tangerine',
                )}
                href={ROUTES.signup}
              >
                CREATE PROFILE
              </a>
            </>
          )}
        </nav>
        <div className="md:hidden max-md:block">
          <HeaderDropdownJC session={session} />
        </div>
      </div>
    </header>
  );
};

export default HeaderJC;
